import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-dialog',
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './ok-dialog.component.html',
    styleUrls: ['./ok-dialog.component.scss']
})
export class OkDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
